<template>
  <div>
    <ly-group>
      <ly-item v-for="(x, index) in dataList" :key="index"
        >{{ x
        }}<Icon @click="dataList.splice(index, 1)" type="ios-backspace-outline"
      /></ly-item>
    </ly-group>
    <div id="wewwwsr">
      <Button @click="openForm = true" size="small" type="primary">添加条目</Button>
      <Button @click="clear" size="small">清空所有</Button>
    </div>

    <Modal v-model="openForm" footer-hide width="400" title="添加条目">
      <Input v-model="item" placeholder="请输入"></Input>
      <div class="clearfloat" style="margin-top: 30px">
        <Button @click="add" type="primary" style="float: right">填好了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: ["dataList"],
  data() {
    return {
      openForm: false,
      item: "",
    };
  },
  methods: {
    add() {
      if (!this.utils.isEmpty(this.item)) {
        this.dataList.push(this.item);
        //this.$emit("aaa", this.dataList);
        this.openForm = false;
        this.item = "";
      } else {
        this.$Message.error("项目不能为空");
      }
    },
    clear() {
      this.dataList.splice(0, this.dataList.length);
    },
  },
  model: {
    prop: "dataList",
    event: "aaa",
  },
};
</script>
<style>
#wewwwsr {
  position: absolute;
  bottom: 0;
  height: 24px;
}

</style>


// WEBPACK FOOTER //
// src/components/common/addItem.vue